import { NavLink, useMatch, useResolvedPath, useLocation } from "react-router-dom";
import { Link } from "react-scroll";
import gcasLogo from "../assets/images/gcas-logo.svg";
import { useState, useEffect } from "react";

function Header() {
	const [isOpen, setIsOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);
	const { pathname } = useLocation();
	// Routes whose hero is a full-bleed photo/video the nav floats over
	// transparently need white nav text for contrast; see DESIGN.md.
	const hasMediaHero = pathname === "/";

	const toggleMenu = () => {
		setIsOpen((open) => !open);
	};

	const closeMenu = () => {
		setIsOpen(false);
	};

	useEffect(() => {
		if (isOpen) {
			document.body.classList.add("no-scroll");
		} else {
			document.body.classList.remove("no-scroll");
		}
	}, [isOpen]);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 40);
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	// Each route starts scrolled to the top (see ScrollToTop), so the
	// header should reset to its unscrolled state immediately on navigation.
	useEffect(() => {
		setScrolled(false);
	}, [pathname]);

	// The open mobile menu is an opaque paper-colored panel, not the media
	// hero itself, so it always needs dark (on-paper) text/logo — even on
	// "/" while unscrolled, where headerOnMedia would otherwise turn them
	// white and make the menu look blank.
	const headerClassName = [
		scrolled ? "headerScrolled" : "",
		hasMediaHero && !scrolled && !isOpen ? "headerOnMedia" : "",
	]
		.filter(Boolean)
		.join(" ");

	return (
		<header className={headerClassName}>
			<nav className={`navBar mobileWidth ${isOpen ? "isOpen" : ""}`}>
				<div className="mobileHeaderOnly">
					<NavLink className="link logo headerLogo" to="/" onClick={closeMenu}>
						<img alt="GCAS Regina" src={gcasLogo} />
					</NavLink>
					<button
						aria-label="Toggle Menu for Navigation"
						className={`hamburger ${isOpen ? "isOpen" : ""}`}
						onClick={toggleMenu}
					>
						<i className="fa-solid fa-bars-staggered"></i>
					</button>
				</div>

				<div className={`navItems ${isOpen ? "isOpen" : ""}`}>
					<CustomLink to="/" onClick={closeMenu}>
						Home
					</CustomLink>
					<CustomLink to="/events" onClick={closeMenu}>
						Events
					</CustomLink>

					<li>
						<Link
							spy={true}
							smooth={true}
							offset={-100}
							duration={500}
							className="navItemAlt"
							href="/"
							to="about"
							onClick={closeMenu}
						>
							About Us
						</Link>
					</li>

					<li>
						<Link
							spy={true}
							smooth={true}
							offset={-100}
							duration={500}
							className="navItemAlt"
							href="/"
							to="contact"
							onClick={closeMenu}
						>
							Contact Us
						</Link>
					</li>
					<button
						aria-label="Join WhatsApp"
						className={`btn btnPrimary navBtn ${isOpen ? "isOpen" : ""}`}
					>
						Join on WhatsApp
						<span className="btnIcon" aria-hidden="true">
							<i className="fa-brands fa-whatsapp"></i>
						</span>
					</button>
				</div>
			</nav>
		</header>
	);
}

function CustomLink({ to, children, onClick, ...props }) {
	const resolvedPath = useResolvedPath(to);
	const isActive = useMatch({ path: resolvedPath.pathname, end: true });

	return (
		<li className={isActive ? "active" : ""}>
			<NavLink className="navItem" to={to} onClick={onClick} {...props}>
				{children}
			</NavLink>
		</li>
	);
}

export default Header;
